import '../../currency-_kacFJHO.js';
import '../../language-BHHwgtQp.js';
import { P as PaymentMethodCode } from '../../payment-5CMab_Gs.js';
import '../../types/index.js';
import { A as ActionStatus } from '../../checkout-ArxiEbYP.js';
import '../../menu-0TyOg98i.js';
import '../../product-_pRduMz7.js';
import '../../modal-6vnX5SO3.js';

const initialState = {
    addresses: [],
    countries: [],
    cart: {
        check_mattress_recovery: false,
        email: null,
        items: [],
        prices: null,
        shipping_addresses: [],
        billing_address: null,
        applied_coupons: [],
        available_payment_methods: [],
        selected_payment_method: null,
    },
    almaPaymentMethod: null,
    expressPaymentMethod: null,
    // TODO: need to set "points" value in thunk by the BE data
    // Currently this is a temporary hardcoded data
    allRewardPointsPaymentMethod: {
        code: PaymentMethodCode.RewardPoints,
        title: 'All Reward Points',
        points: 233.52,
    },
    processPayment: {
        generalStatus: ActionStatus.Idle,
        validationStatus: {
            email: ActionStatus.Idle,
            shipping: ActionStatus.Idle,
            billing: ActionStatus.Idle,
            paymentMethod: ActionStatus.Idle,
        },
        requestStatus: {
            email: ActionStatus.Idle,
            shipping: ActionStatus.Idle,
            paymentMethod: ActionStatus.Idle,
        },
        payload: {
            email: null,
            shipping: null,
            billing: null,
            paymentMethod: null,
        },
    },
    updateCustomerData: {
        initCount: 0,
        payload: {
            email: null,
            firstName: null,
            lastName: null,
            phoneNumber: null,
            countryCode: null,
            region: null,
            city: null,
            address1: null,
            address2: null,
            postCode: null,
        },
    },
    loadingShippingFeeAndPaymentMethod: false,
    loadingPaymentButton: false,
    extraErrors: null,
};

export { initialState };
//# sourceMappingURL=initialState.js.map
